module.exports = __webpack_public_path__ + "static/media/Technologybanner.bf94d98a.png";